import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router";
import Business from "./pages/Business";
import Home from "./pages/Home";
import Log from "./pages/Log";
import Onboard from "./pages/Onboard";
import Settings from "./pages/Settings";

function App() {
  const queryClient = new QueryClient();
  return (
    <div className="App">
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/business/:gstin" element={<Business />} />
            <Route path="/businesses" element={<Home />} />
            <Route path="/onboard" element={<Onboard />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/log" element={<Log />} />
          </Routes>
        </BrowserRouter>
      </QueryClientProvider>
    </div>
  );
}

export default App;
